import { logError } from 'commons/logger';
import { logEvent } from 'commons/utils/tracking';
import {
  AI_AGENT_CHAT_MESSAGE_SENT,
  AI_AGENT_CHAT_SUGGESTION_USED,
  AI_AGENT_CHAT_CONVERSATION_RESET,
  AI_AGENT_CHAT_ACTION_GENERATED,
  AI_AGENT_CHAT_ACTION_ACCEPTED,
} from 'config/trackingEvents';
import type {
  TrackAgentChatMessageSentPayload,
  TrackAgentChatSuggestionUsedPayload,
  TrackAgentChatConversationResetPayload,
  TrackAgentChatActionGeneratedPayload,
  TrackAgentChatActionAcceptedPayload,
} from './types';

const safeStringify = (value: unknown) => {
  try {
    return JSON.stringify(value ?? {});
  } catch (error) {
    logError('Error stringifying context', error, {
      value,
    });
    return '';
  }
};

export const trackAgentChatMessageSent = ({
  messageContent,
  sessionId,
  runId,
  imageUrls,
  currentRoute,
  context,
}: TrackAgentChatMessageSentPayload) => {
  logEvent(AI_AGENT_CHAT_MESSAGE_SENT, {
    message_text: messageContent,
    session_id: sessionId ?? 'null',
    run_id: runId ?? 'null',
    current_route: currentRoute,
    image_urls: imageUrls.length ? imageUrls : [],
    context_payload: safeStringify(context),
  });
};

export const trackAgentChatSuggestionUsed = ({
  suggestion,
  sessionId,
}: TrackAgentChatSuggestionUsedPayload) => {
  logEvent(AI_AGENT_CHAT_SUGGESTION_USED, {
    suggestion_text: suggestion,
    session_id: sessionId ?? 'null',
  });
};

export const trackAgentChatConversationReset = ({
  messageCount,
  sessionId,
}: TrackAgentChatConversationResetPayload) => {
  logEvent(AI_AGENT_CHAT_CONVERSATION_RESET, {
    message_count: String(messageCount),
    session_id: sessionId ?? 'null',
  });
};

export const trackAgentChatActionGenerated = ({
  runId,
  sessionId,
  actions,
}: TrackAgentChatActionGeneratedPayload) => {
  logEvent(AI_AGENT_CHAT_ACTION_GENERATED, {
    run_id: runId ?? 'null',
    session_id: sessionId ?? 'null',
    action_chain: safeStringify(actions),
  });
};

export const trackAgentChatActionAccepted = ({
  runId,
  sessionId,
  actions,
}: TrackAgentChatActionAcceptedPayload) => {
  logEvent(AI_AGENT_CHAT_ACTION_ACCEPTED, {
    run_id: runId ?? 'null',
    session_id: sessionId ?? 'null',
    action_chain: safeStringify(actions),
  });
};
